import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var CustomerService = /** @class */ (function () {
    function CustomerService(http, config) {
        this.http = http;
        this.config = config;
    }
    CustomerService.prototype.datatable = function (f) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/customers/dt", f);
    };
    CustomerService.prototype.getAll = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/customers");
    };
    CustomerService.prototype.get = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/customers/" + id);
    };
    CustomerService.prototype.update = function (ana) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/customers", ana);
    };
    CustomerService.prototype.insert = function (ana) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/customers", ana);
    };
    CustomerService.prototype.delete = function (id) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/customers/" + id);
    };
    CustomerService.ngInjectableDef = i0.defineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: CustomerService, providedIn: "root" });
    return CustomerService;
}());
export { CustomerService };
